import { baseURL } from "../services/apiConstants";
import { ErrorToast } from "../widgets/AppToast";

export const DOWNLOADPDF = (downloadPdfUrl, voyage_id, startDate, endDate) => {
  const login_token = localStorage.getItem("login_token");
  if (!login_token) {
    ErrorToast("Download Error", "Unable to generate download link.");
    return;
  }
  const url = `${baseURL}/${downloadPdfUrl}/${voyage_id}/${startDate}/${endDate}/${login_token}/`;
  window.open(url, "_blank");
};

export const GENERATEREPORT = (downloadPdfUrl, voyage_id, startDate, endDate, requestType) => {
  const login_token = localStorage.getItem("login_token");
  if (!login_token) {
    ErrorToast("Download Error", "Unable to generate download link.");
    return;
  }
  const url = `${baseURL}/${downloadPdfUrl}/${voyage_id}/${startDate}/${endDate}/${requestType}/`;
  window.open(url, "_blank");
};
